import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Modal,
  Close,
  Header,
  Body,
  Footer
} from "MODULES/shared/components/Modal";
import { CANCELLATION_REASONS } from "MODULES/PurchaseOrders/constants";
import { updateLineItem } from "MODULES/Lots/actions";

class CancelModal extends React.Component {
  state = {
    cancellationReason: "previously_sold"
  };

  sendRequestAndClose = data => {
    const { update, close, lineItem } = this.props;

    update(lineItem.id, data);
    close();
  };

  handleSelectChange = e => {
    this.setState({ cancellationReason: e.target.value });
  };

  render() {
    const { lineItem, open, close } = this.props;
    const { cancellationReason } = this.state;

    return (
      <Modal open={open} close={close} dialogClass="modal-sm">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">Cancel Part</h4>
        </Header>
        <Body>
          <div>
            <label className="control-label" htmlFor="cancellation_reason">
              Cancellation Reason
            </label>
            <select
              className="form-control"
              name="cancellation_reason"
              onChange={e => this.handleSelectChange(e)}
            >
              {CANCELLATION_REASONS.map(reason => (
                <option key={reason.value} value={reason.value}>
                  {reason.text}
                </option>
              ))}
            </select>
          </div>
        </Body>
        <Footer>
          <button type="button" className="btn btn-default" onClick={close}>
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            onClick={() =>
              this.sendRequestAndClose({
                cancelled: !lineItem.cancelled,
                cancellation_reason: cancellationReason
              })}
          >
            Save
          </button>
        </Footer>
      </Modal>
    );
  }
}

CancelModal.propTypes = {
  lineItem: PropTypes.shape({}).isRequired,
  open: PropTypes.bool,
  close: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired
};

export default connect(undefined, dispatch => ({
  update: (id, data) => dispatch(updateLineItem(id, data))
}))(CancelModal);



// WEBPACK FOOTER //
// ./app/modules/Lots/Detail/LineItemsTable/CancelModal.jsx